// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"91709335","453":"5b575ede","455":"5ab52d1a"}[chunkId] + ".chunk.js";
};